import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { faq } from "../data/faq";

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section id="faq" data-testid="faq-section" className="py-24 md:py-32 bg-[#F7F3EA]">
      <div className="max-w-[900px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#C9A869]" />
            <span className="text-[11px] tracking-[0.4em] uppercase text-[#C9A869]">FAQ</span>
            <span className="h-px w-10 bg-[#C9A869]" />
          </div>
          <h2 className="serif font-light text-4xl md:text-5xl lg:text-6xl text-[#2B2B31] tracking-tight">
            Vos questions, mes <span className="italic" style={{ color: "#C9A869" }}>réponses</span>.
          </h2>
        </div>

        <div className="border-t border-[#2B2B31]/15">
          {faq.map((item, i) => (
            <div key={i} className="border-b border-[#2B2B31]/15">
              <button
                data-testid={`faq-toggle-${i}`}
                onClick={() => setOpen(open === i ? -1 : i)}
                className="w-full flex items-center justify-between text-left py-6 group"
              >
                <span className="serif text-xl md:text-2xl text-[#2B2B31] pr-6 group-hover:text-[#C9A869] transition-colors">
                  {item.q}
                </span>
                <span className="shrink-0 w-9 h-9 flex items-center justify-center border border-[#C9A869]/50 text-[#C9A869]">
                  {open === i ? <Minus size={16} /> : <Plus size={16} />}
                </span>
              </button>
              {open === i && (
                <div className="pb-7 pr-12 text-[#2B2B31]/75 leading-relaxed font-light text-base animate-fade-up">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
